import styled, { css } from "styled-components";

export const CheckboxGridRow = styled.div`
  // display: grid;
  // grid-template-columns: ${(props) => props.column};
  // overflow-y: auto;
  // height: 100%;
  column-count: 3;
  margin: 10px;
`;

export const DepartmentCountText = styled.span`
  font-size: 14px;
  color: #767676;
  font-style: italic;
  float: right;
`;
